import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  constructor() {}

  public generateSchema(path: string): any {
    const actualLink = `https://songdew.com${path.split('?')[0]}`;
    const linkArray = actualLink.split('-');
    const slugArray = actualLink.split('/');
    const lastSlug = slugArray[slugArray.length - 1];

    // ✅ Home Page
    if (actualLink === 'https://songdew.com' || actualLink === 'https://songdew.com/') {
      return {
        "@context": "http://schema.org/",
        "@type": "Thing",
        "alternateName": "Songdew",
        "description": "Songdew The fast growing network of Musicians for Distribute, Promote and Monetize",
        "image": {
          "@type": "ImageObject",
          "isAccessibleForFree": "yes",
          "isFamilyFriendly": "yes",
          "keywords": "Distribute, Promote and Monetize ",
          "thumbnailUrl": "https://songdew.com/images/songdewlogo.png"
        },
        "mainEntityOfPage": "https://songdew.com/",
        "name": "Distribute, Promote and Monetize your music"
      };
    }

    // 📌 Note: These other sections require DB data. We'll show placeholders and simulate fetching.

    // ✅ Albums Page (simulate via mock or from a resolver service)
   /* if (actualLink.includes('/albums/') && !isNaN(+linkArray[linkArray.length - 1])) {
      const albumId = +linkArray[linkArray.length - 1];
      return {
        "@context": "http://schema.org/",
        "@type": "MusicAlbum",
        "numTracks": "10",
        "alternativeHeadline": "Sample Album by Sample Artist",
        "contentRating": "5",
        "datePublished": "2023-01-01",
        "fileFormat": "mp3",
        "genre": "Indie",
        "headline": "Sample Album",
        "isAccessibleForFree": "1",
        "isFamilyFriendly": "1",
        "keywords": "Sample Artist music album, Sample Album",
        "publisher": "Songdew",
        "thumbnailUrl": "https://media.songdew.com/sgmedia/sample.jpg",
        "timeRequired": "30:00",
        "alternateName": "Sample Artist Music Album",
        "description": "Sample album description",
        "mainEntityOfPage": actualLink,
        "name": "Sample Album"
      };
    }
      */

    // ✅ Playlists
  /*  if (actualLink.includes('/playlists/') && !isNaN(+linkArray[linkArray.length - 1])) {
      return {
        "@context": "http://schema.org/",
        "@type": "MusicPlaylist",
        "numTracks": "12",
        "track": actualLink,
        "about": "Thing",
        "alternativeHeadline": "Sample Playlist",
        "contentRating": "5",
        "contributor": "Songdew",
        "datePublished": "2023-01-01",
        "fileFormat": "mp3",
        "headline": "Sample Playlist",
        "isAccessibleForFree": "1",
        "isFamilyFriendly": "1",
        "keywords": "Sample Playlist playlist, Sample Playlist music 2019",
        "license": "Songdew",
        "thumbnailUrl": "https://media.songdew.com/sgmedia/sample-playlist.jpg",
        "timeRequired": "25:00",
        "alternateName": "Sample Playlist Music 2019",
        "description": "Listen the Sample Playlist music songs 2019",
        "mainEntityOfPage": actualLink
      };
    }
*/
    // ✅ Video Songs
  /*  if (actualLink.includes('/video-songs/') && !isNaN(+linkArray[linkArray.length - 1])) {
      return {
        "@context": "http://schema.org/",
        "@type": "MusicVideoObject",
        "contentUrl": actualLink,
        "duration": "",
        "embedUrl": "https://www.youtube.com/watch?v=VIDEO_ID",
        "playerType": "MP4",
        "uploadDate": "2023-01-01",
        "alternativeHeadline": "Sample Video - Sample Artist",
        "headline": "Sample Video - Sample Artist",
        "isAccessibleForFree": "1",
        "isFamilyFriendly": "1",
        "keywords": "Pop video songs, Pop mp4 songs",
        "description": "Sample video description",
        "mainEntityOfPage": actualLink,
        "name": "Sample Video - Sample Artist"
      };
    }
*/
    // ✅ Artist Profile Page
   /* if (lastSlug && isNaN(+lastSlug)) {
      return {
        "@context": "http://schema.org/",
        "@type": "MusicGroup",
        "album": {
          "@type": "MusicAlbum",
          "numTracks": "8",
          "isFamilyFriendly": "1",
          "keywords": "Sample Artist Indie, Indie music albums",
          "thumbnailUrl": "https://media.songdew.com/sgmedia/sample-artist.jpg",
          "mainEntityOfPage": actualLink,
          "name": "Artist - Sample Artist"
        },
        "track": [
          "https://songdew.com/songs/sample-song-1",
          "https://songdew.com/songs/sample-song-2"
        ],
        "genre": "Indie"
      };
    }
*/
    // ✅ Default Fallback
    return {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": actualLink,
      "name": "Songdew"
    };
  }
}
